export enum ORDER_STATUS_PERMISSIONS {
  ORDER_STATUS_VIEW = 'ORDER_STATUS_VIEW',
  ORDER_STATUS_WRITE = 'ORDER_STATUS_WRITE',
}
